module.exports = __webpack_public_path__ + "static/media/2023_37.0b222c82.jpg";